module.exports.flattenObject = (obj, parentKey = "") => {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = parentKey ? `${parentKey}.${key}` : key;

    if (typeof obj[key] === "object" && obj[key] !== null) {
      return { ...acc, ...this.flattenObject(obj[key], newKey) };
    } else {
      return { ...acc, [newKey]: obj[key] };
    }
  }, {});
};

module.exports.getFinalKeySegment = (key) => {
  const segments = key.split(".");
  return segments[segments.length - 1];
};

module.exports.snakeToTitle = (str) => {
  if (str !== undefined) {
    let newStr = str.replace(/_([a-z])/g, function (match, letter) {
      return " " + letter.toUpperCase();
    });
    newStr = newStr.charAt(0).toUpperCase() + newStr.slice(1);

    // TODO: Special case for 'Stable Species'
    if (newStr == "Stable Species") {
      newStr = "Adsorbed State";
    }
    return newStr;
  } else {
    return "";
  }
};

module.exports.castToFloatAndReducePrecision = (obj) => {
  // Check if the object is castable to a float
  const floatValue = parseFloat(obj);

  if (!isNaN(floatValue)) {
    // If castable, reduce it to 3 decimals of precision
    const roundedValue = parseFloat(floatValue.toFixed(3));
    return roundedValue;
  } else {
    // If not castable, return obj
    return obj;
  }
};

// Get data from nested JS object
module.exports.getPath = (p, o) =>
  p.reduce((xs, x) => (xs && xs[x] !== null ? xs[x] : null), o);

module.exports.collectRelated = (datasets, path) => {
  return datasets.map((data) => {
    return module.exports.getPath(path, data);
  });
};

module.exports.openInNewTab = (href) => {
  var a = document.createElement("a");
  a.href = href;
  var evt = document.createEvent("MouseEvents");
  //the tenth parameter of initMouseEvent sets ctrl key
  evt.initMouseEvent(
    "click",
    true,
    true,
    window,
    0,
    0,
    0,
    0,
    0,
    true,
    false,
    false,
    false,
    0,
    null,
  );
  a.dispatchEvent(evt);
};

module.exports.openAndGoTo = (href) => {
  window.open(href);
};
